var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2435 26.1079C18.2748 27.1104 14.8193 26.2662 12.6701 23.5741C10.4402 20.7812 10.4438 16.7217 12.6777 13.9324C15.6213 10.2567 21.0046 10.0366 24.2405 13.272C26.9455 15.9771 27.2352 20.1831 25.1097 23.2096C24.6507 23.8642 24.7592 24.7621 25.3245 25.3279L29.5 29.5034",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.753123c293ac7d9c7fe8a2ea6a8d3e75.svg";
export { ForwardRef as ReactComponent };